import { Grid, Paper } from "@material-ui/core";
import { vendorDashStyle } from "../style";
import { GraphLoader } from "../GraphLoader";
import ExportButton from "components/ExportButton/ExportButton";
import { IconDownload } from "icons";
import ServiceListDialog from "../ServicesGraphWidget/ServiceListDialog";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

export const StatsWidget = ({
    title,
    description,
    statsText,
    isLoading,
    content,
    mapExportData,
    data,
    icon,
    noShadow = false,
    tableData,
    trend = null
}) => {
    const classes = vendorDashStyle();
    return (
        <Paper className={`${classes.statCard} ${noShadow && classes.noShadow}`} elevation={noShadow ? 1 : 0} >
            <Grid container direction="column" spacing={1}>
                <Grid container justifyContent="space-between" item className={classes.statTitle}>
                    <Grid item className={classes.statTitle}>
                        {icon}
                        <div style={{ margin: 0 }}>
                            {title}
                        </div>
                    </Grid>
                    {<Grid item conatiner justifyContent="flex-end" alignItems="center">
                        {tableData && <ServiceListDialog activities={tableData} />}
                        {mapExportData && <ExportButton className={classes.exportButton} btnStyle='text' label="" icon={<IconDownload />}
                            fileLabel="Export" data={data} mapExportData={mapExportData} />}
                    </Grid>}
                </Grid>
                <Grid item className={classes.statCount}>
                    {statsText}
                    {trend < 0 ?
                        <ArrowDownwardIcon fontSize="small" style={{ padding: '3px', marginLeft: '.5rem', fill: '#08db80' }} />
                        : trend > 0 ?
                            <ArrowUpwardIcon fontSize="small" color="error" style={{ padding: '3px', marginLeft: '.5rem' }} />
                            : null
                    }
                </Grid>
                <Grid item>
                    {content}
                </Grid>
                <Grid item className={classes.statDesc}>{description}</Grid>
            </Grid>
            <GraphLoader loading={isLoading} />
        </Paper>
    )
}